import { CompanyContext } from "contexts/CompanyContext";
import { SessionContext } from "contexts/SessionContext";
import { useContext } from "react";

const usePostGenerationQuantity = (getMaximum = false) => {

    const { mainUser } = useContext(CompanyContext);

    const maximum = 5;
    const minimum = 2;

    if (getMaximum) {
        return maximum;
    }

    if (!!mainUser?.subscription) {
        return maximum;
    }

    return minimum;
}

export default usePostGenerationQuantity;